
import getDocument from './get-document';

export default function (node) {
  var _document = getDocument(node);
  return _document.defaultView || window;
}
//# sourceMappingURL=get-window.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/esm/util/get-window.js
// module id = 454
// module chunks = 4